import { Component } from "@angular/core";
import { ViewController, NavParams } from "ionic-angular";
import {
  Topic,
  TopicItem,
  IRelevantSupportActionModalNavParams
} from "../../../../app/models/types";
import { RelevantSupportActionsModal } from "../../../../modals/relevant-support-actions.modal/relevant-support-actions.modal";
import { ModalController } from "ionic-angular/components/modal/modal-controller";
import { DiaprofilPatient } from "../../../../app/models/diaprofil-patient";
import {
  EventLoggingService,
  LogEventId
} from "../../../../app/services/event-logging.service";
import { DiaprofilProTask } from "../../../../app/models/diaprofil-pro-task";

@Component({
  selector: "topic-answers-modal",
  templateUrl: "topic-answers.modal.html"
})
export class TopicAnswersModal {
  topic: Topic = { id: null, i18n: null, topicType: null, freeTextFields: {} };
  topicItems: TopicItem[] = [];
  patient: DiaprofilPatient;
  task: DiaprofilProTask;
  constructor(
    public viewCtrl: ViewController,
    private navParams: NavParams,
    private modalCtrl: ModalController,
    private eventLogging: EventLoggingService
  ) {
    this.topic = this.navParams.get("topic") || {};
    this.topicItems = this.navParams.get("topicItems") || [];
    this.patient = this.navParams.get("patient") || {};
    this.task = this.navParams.get("task") || {};
  }

  openRelevantSupportActionsModal(items: TopicItem[], title) {
    this.eventLogging.saveEvent({
      event_id: LogEventId.OPEN_SUPPORT_ACTION_MODAL,
      event_src_location: "TopicCard",
      parent_task_uuid: this.task.task.id,
      qnr_response_uuid: this.task.response.id,
      patient_fhir_id: this.patient.fhirId,
      patient_full_name: this.patient.fullName,
      additional_info: {
        topicName: this.topic.id,
        items: items.map(x => x.config.name).join()
      }
    });
    const data: IRelevantSupportActionModalNavParams = {
      supportFor: {
        proItems: items,
        patientWishes: [],
        consultationTopics: [],
        scoreIds: []
      },
      patient: this.patient,
      modalType: "PRO_ITEM",
      modalTitle: title
    };
    const modal = this.modalCtrl.create(RelevantSupportActionsModal, data, {
      cssClass: "large-modal",
      enableBackdropDismiss: false
    });
    modal.present();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard.page/topic-card.component/topic-answers.modal/topic-answers.modal.ts